import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center">
      <div className="text-center">
        <p className="text-sm font-medium text-slate-500">404</p>
        <h1 className="mt-1 text-xl font-semibold">Page not found</h1>
        <Link to="/" className="mt-3 inline-block text-sm text-blue-600 hover:underline">
          Back to dashboard
        </Link>
      </div>
    </div>
  )
}
